export default __webpack_public_path__ + "images/c231eca8393b531566672a4875e72067-sbif.svg";